import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { findIndex, isEmpty,isUndefined } from "lodash"
import { Route, Redirect } from "react-router-dom"
import { retrieveValues, clearStore } from "../../helpers/storagewrapper.js"

function PrivateRoute({ module, ...rest }) {
  let access = false

  try {
    const authUser=retrieveValues("authUser");
    // console.debug(JSON.stringify(authUser))
    const obj = JSON.parse(authUser)

    const controls = obj?.data?.controls || {}

    if (isUndefined(obj?.data?.controls)) {
      return (<Redirect to="/login" />)
    } else if (obj?.data?.type == "SUPER_ADMIN" || module == "dashboard") {
      access = true
    } else if (!isEmpty(controls)) {
      Object.keys(controls).map((type, index) => {
        let findIndex = controls[type].findIndex(
          el => el.key == module && el.selected == true
        )
        if (findIndex > -1 && !access) {
          access = true
        }
      })
    } else {
      clearStore()
      return (<Redirect to="/login" />)
    }
  } catch (err) {
    console.warn("privateRoute error "+err?.stack||err)
    clearStore()
    return <Redirect to="/login" />

  }
  
  return (
    <Route
      {...rest}
      render={() =>
        access ? <Route {...rest} /> : <Redirect to="/exception/403" />
      }
    />
  )
}

PrivateRoute.propTypes = {
  module: PropTypes.string,
  children: PropTypes.any,
}

export default PrivateRoute
